import { __assign, __extends } from "tslib";
import React from 'react';
import ErrorReporterLib from '@bookingcom/error-reporter';
export { defaultTransformer, affiliateTransformer, nodeJSTransformer } from '@bookingcom/error-reporter';
export var ErrorContext = React.createContext({});
var ErrorReporter = /** @class */ (function (_super) {
    __extends(ErrorReporter, _super);
    function ErrorReporter(props) {
        var _this = _super.call(this, props) || this;
        _this.reporter = props.reporter || new ErrorReporterLib(props);
        return _this;
    }
    ErrorReporter.prototype.componentDidUpdate = function (prevProps) {
        if (process.env.NODE_ENV !== 'production' && prevProps.reporter !== this.props.reporter) {
            console.warn('[react-error-reporter] ErrorReporter cannot be updated in props');
        }
    };
    ErrorReporter.prototype.render = function () {
        return (React.createElement(ErrorContext.Provider, { value: this.reporter },
            React.createElement(ErrorBoundary, __assign({}, this.props), this.props.children)));
    };
    return ErrorReporter;
}(React.Component));
var ErrorBoundary = /** @class */ (function (_super) {
    __extends(ErrorBoundary, _super);
    function ErrorBoundary(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { hasError: false, error: null };
        return _this;
    }
    ErrorBoundary.prototype.componentDidCatch = function (error, info) {
        try {
            var componentStack = info ? info.componentStack + '\n' : '';
            error.stack = componentStack + error.stack;
            this.context.sendError(error);
        }
        catch (err) {
            if (process.env.NODE_ENV !== 'production') {
                console.warn('[react-error-reporter] Something went wrong logging this error');
                console.error(err);
            }
        }
    };
    ErrorBoundary.getDerivedStateFromError = function (error) {
        return { hasError: true, error: error };
    };
    ErrorBoundary.prototype.render = function () {
        if (process.env.NODE_ENV !== 'production' && !this.context) {
            console.warn('[react-error-reporter] ErrorBoundary defined outside of ErrorReporter');
        }
        if (this.state.hasError) {
            return React.createElement(this.props.errorDisplayComponent, {
                error: this.state.error
            });
        }
        return this.props.children;
    };
    ErrorBoundary.defaultProps = {
        endpoint: '/js_errors',
        handleWindowErrors: false,
        maxErrorsToReport: 5,
        payloadContentType: 'multipart/form-data'
    };
    return ErrorBoundary;
}(React.Component));
export { ErrorBoundary };
ErrorBoundary.contextType = ErrorContext;
export default ErrorReporter;
//# sourceMappingURL=index.js.map